<script setup lang="ts">
  const props = defineProps<{
    label: string;
    value: string;
  }>();
</script>

<template>
  <div>
    <div class="text-gray-07 text-sm/5 w-full text-left font-semibold mb-2">
      {{ props.label }}
    </div>
    <div
      class="rounded-2xl border border-light-gray-xx bg-gray-02/20 px-5 h-15 flex items-center"
    >
      <div>{{ props.value }}</div>
    </div>
  </div>
</template>
